module.exports = __webpack_public_path__ + "static/media/logo-reddit.4ee9a163.svg";